import { VendorRepository } from "../../repositories/VendorRepository";
import {
  VendorOperationResult,
  VendorEntity,
} from "../../entities/VendorEntity";

/**
 * Create Vendor Use Case
 * Creates a new vendor in the system
 */
export class CreateVendorUseCase {
  constructor(private repository: VendorRepository) {}

  async execute(
    vendorData: Partial<VendorEntity>
  ): Promise<VendorOperationResult> {
    return await this.repository.createVendor(vendorData);
  }
}
